import React, { useEffect } from "react";
import $ from "jquery";
import * as GC from "../../../../common/common";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";
import * as CommonFunctions from "../functions/commonFunctions";

const Grootboek = () => {
  useEffect(() => {
    $("#grootboek").on("show.bs.modal", function (event) {
      GC.GetEntityList(
        process.env.REACT_APP_GROOTBOEK,
        1,
        30,
        CallBackFunctions.GrootboekCallback,
        window.$catalog_management_units_token
      );
    });
  });

  const handleClick = () => {
    $("#cover-spin").show(0);
    var disciplineId = $("input[name=discipline]:checked").attr("id");
    var model = { grootboeknummer: disciplineId };
    var selectedIds = [];
    $("#example")
      .dataTable()
      .$("tr.selected")
      .each(function () {
        selectedIds.push($(this).attr("rowId"));
      });

    GC.StartActivity(
      model,
      selectedIds,
      "4b2b5976-21e5-4810-8f58-adf0e8ecf481",
      grootboekSaved,
      window.$catalog_management_units_token
    );

    function grootboekSaved() {
      GC.sleep(500).then(() => {
        $("#grootboek").modal("hide");
        window.$catalog_measures_refresh();
        /*omnimap
          .FillTableAction(
            window.$catalog_measures_last_used_table_filter,
            1,
            window.$catalog_management_units_token
          )
          .then((result) => {
            CallBackFunctions.FillTableCallBack(result, 1);
          });*/
      });
    }
  };

  return (
    <div className="modal fade" tabIndex={-1} role="dialog" id="grootboek">
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Grootboeknummer</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body">
            <input type="search" className="modal-search" placeholder="" />
            <div className="modal-scroll">
              <div id="grootboeknummer-grp" className="radio-grp" />
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              id="save_grootboeknummer"
              className="btn-modal"
              onClick={handleClick}
            >
              Verwerken
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Grootboek;
